import {BatteryIcons, BatteryVoltages} from '../Report/RenderHelpers'
import { nestedProp } from '../Utils/object';

export function csvExport (filename, rows) {
    var processRow = function (row) {
        var finalVal = '';
        if (!row) return
        for (var j = 0; j < row.length; j++) {
            var cell;
            if (row[j] instanceof Date) {
                cell = row[j].toLocaleString();
            }
            else {
                cell = (row[j] === null || row[j] === undefined) ? '' : row[j].toString();
            }
            let result = cell
            if (! cell.startsWith("=")) {
                result = cell.replace(/"/g, '""');
                if (result.search(/("|,|\n)/g) >= 0)
                    result = '"' + result + '"';  
            }
            if (j > 0)
                finalVal += ',';
            finalVal += result;
        }
        return finalVal + '\n';
    };

    var csvFile = '';
    for (var i = 0; i < rows.length; i++) {
        csvFile += processRow(rows[i]);
    }

    var blob = new Blob([csvFile], { type: 'text/csv;charset=utf-8;' });
    if (navigator.msSaveBlob) { // IE 10+
        navigator.msSaveBlob(blob, filename);
    } else {
        var link = document.createElement("a");
        if (link.download !== undefined) { // feature detection
            // Browsers that support HTML5 download attribute
            var url = URL.createObjectURL(blob);
            link.setAttribute("href", url);
            link.setAttribute("download", filename);
            link.style.visibility = 'hidden';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
    }
}
export function convertToFileName(source) {
    return source.replace(/[/|\\:*?"<> ]/g, "");
}
export function csvFileName(source) {
    let fname = source ? convertToFileName(source) : "csvreport"
    if (!fname.endsWith('.csv')) 
        fname = fname.concat ('.csv')
    return fname
}
export function csvDownload(tableId, toCSV, fileName, note=undefined) {
    const iconStr = 'data-icon="'
    const battIcons = BatteryIcons();
    const battVolts = BatteryVoltages();
    let report = [];
    if (note) {
        if (Array.isArray(note)){
            report.push (note)
        }
        else {
            let temp = []
            temp.push(note)
            report.push(temp)
        }
    }
    const displaytable = document.getElementById(tableId);
    if (displaytable) {
      for (var i = 0; i < displaytable.rows.length; i++) {
        const objCells = displaytable.rows.item(i).cells;
        let rowarray = [];
        for (var j = 0; j < objCells.length; j++) {
            if (Array.isArray(toCSV) && (toCSV[j] === false || j>=toCSV.length))
                continue; 
            const cell = objCells.item(j).innerHTML;
            if (cell.startsWith("<input")) {
                const content = cell.match(/value="(.*?)">/)
                content ? rowarray.push(content[1]) : rowarray.push('');
                //console.log (objCells.item(j).innerHTML.match(/value="(.*?)">/)[1])
            }
            else if (cell.startsWith("<span")) {
                const sless = cell.replace(/<\/?span[^>]*>/g, '')
                const content = sless.replace("&nbsp;", "").trim()
                content ? rowarray.push(content) : rowarray.push('')
            }
            else if (cell.includes(iconStr) && i > 0) {
                // eslint-disable-next-line no-loop-func
                let leFound = battIcons.findIndex((icon) => cell.includes(icon.iconName));
                if (leFound >= 0) // not found? not a battery icon
                    rowarray.push (battVolts[leFound]);
            }
            else if (cell.includes("<button")) {
                rowarray.push(objCells.item(j).textContent);
            }
            else if (i === 0) {
                rowarray.push(objCells.item(j).textContent);
            }
            else
                rowarray.push(cell);
        }
        report.push(rowarray);
      }
      const fname = csvFileName(fileName)
      csvExport (fname, report);
    }
}
export function objToCSV(data, props) {
    if (!(Array.isArray(data) && Array.isArray(props)))
        return undefined
    const report = data.map (row=>props.map(p=>nestedProp(row,p)))
    return report
}
export function updateCSVCol (csv, colIndex, value) {
    return csv.map (row=> {row[colIndex] = value; return row})
}
export function csvFormat (data, format) {
    const step1 = data.map(row=>row.map(
        (col, index)=>format[index] === 'quoted' ? "=\""+(col??'')+"\"" : col))
    return step1
}
